module.exports = require('./formatCurrency')
